import React from 'react';
import { Hidden } from '@material-ui/core';
import useStatus from '../../../hooks/index/useStatus';
import LinkOrAnchor from '../../common/LinkOrAnchor';

const CenterBanner = () => {
  const { siteBannerPC, siteBannerMobile } = useStatus();

  return (
    <>
      {siteBannerPC && (
        <Hidden xsDown>
          <LinkOrAnchor to={siteBannerPC.url}>
            <img
              src={siteBannerPC?.image.url}
              alt="하단배너"
              width="100%"
              height="auto"
            />
          </LinkOrAnchor>
        </Hidden>
      )}
      {siteBannerMobile && (
        <Hidden smUp>
          <LinkOrAnchor to={siteBannerMobile.url}>
            <img
              src={siteBannerMobile?.image.url}
              alt="모바일하단배너"
              width="100%"
              height="auto"
            />
          </LinkOrAnchor>
        </Hidden>
      )}
    </>
  );
};

export default CenterBanner;
